import styles from './privacypolicymodalwrapper.module.css';
import { Popup } from '../../../../shared/ui/Popup';
import { PrivacyPolicy } from '../PrivacyPolicy/PrivacyPolicy';
import { useNavigate } from 'react-router-dom';

interface IPrivacyPolicyModalWrapperProps {
    isOpen: boolean;
}

export function PrivacyPolicyModalWrapper({ isOpen }: IPrivacyPolicyModalWrapperProps) {
    const navigate  = useNavigate();

    function closeModal() {
        navigate(-1); // возвращаемся на предыдущий маршрут
    }

    return (
        <Popup onClose={closeModal} state={isOpen}>
            <div className={styles.privacyPolicyBody}>
                <div className={styles.contentWrapper}>
                    <div className={styles.privacyPolicyContent}><PrivacyPolicy /></div>
                </div>
                <button onClick={closeModal} className={styles.closeButton}>Закрыть</button>
            </div>
        </Popup>
    );
}
